const ASSESSMENT_STORAGE_KEYS = [
  "mpay_resultsData",
  "mpay_personalInfo",
  "mpay_categoryPreferences",
  "mpay_lastCategory",
  "mpay_advisorPublicId",
];

// Advisor marketing link attribution (?advisor=<public_id>), carried to lead creation.
export const ADVISOR_ATTRIBUTION_KEY = "mpay_advisorPublicId";

export function clearMoneyPersonalityAssessmentState(storage: Storage = localStorage) {
  ASSESSMENT_STORAGE_KEYS.forEach((key) => {
    storage.removeItem(key);
  });
}

export { ASSESSMENT_STORAGE_KEYS };
